import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Genericsurvey report',
      'SUBTITULO': 'Consult the generic survey report by entering',
      'CAMPOS': {
        'Token': 'Token:',
      },
      'RESULTADOS': {
        'CARGANDO': 'Loading search results',
        'TITULO': 'Results',
        'ENCONTRADAS': 'Total users found',
        'DESCARGAR': 'Download information in Excel format',
        'SINRESULTADOS': 'No users found for the specified token',
      }
    }
  }
};
